import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faCalendarAlt, faMicrophone, faHeart, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Snackbar, Alert } from '@mui/material';
import '../../styles/group/CreateButton.css';
import CreateEventModal from './CreateEventModal';
import CreateClassModal from './CreateClassModal';
import CreateMembershipModal from './CreateMembershipModal';

const CreateButton = ({ groupId, activeTab }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isEventModalOpen, setIsEventModalOpen] = useState(false);
  const [isClassModalOpen, setIsClassModalOpen] = useState(false);
  const [isMembershipModalOpen, setIsMembershipModalOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleOptionClick = (option) => {
    if (option === 'event') {
      setIsEventModalOpen(true);
    } else if (option === 'class') {
      setIsClassModalOpen(true);
    } else if (option === 'membership') {
      setIsMembershipModalOpen(true);
    }
    setIsMenuOpen(false);
  };

  const handleEventCreated = (eventData) => {
    // Only proceed if we actually have valid event data
    if (!eventData || !eventData.title) {
      console.log('handleEventCreated called without valid data, ignoring');
      return;
    }
    
    console.log('Event successfully created:', eventData);
    
    // Show success message
    setSnackbarMessage(`Event "${eventData.title}" created successfully!`);
    setSnackbarOpen(true);
    
    // Refresh the page to show the new event after a short delay
    setTimeout(() => {
      window.location.reload();
    }, 1500);
  };

  const handleClassCreated = (classData) => {
    // Only proceed if we actually have valid class data
    if (!classData || !classData.title) {
      console.log('handleClassCreated called without valid data, ignoring');
      return;
    }
    
    console.log('Class successfully created:', classData);
    
    // Show success message
    setSnackbarMessage(`Class "${classData.title}" created successfully!`);
    setSnackbarOpen(true);
    
    // Refresh the page to show the new class after a short delay
    setTimeout(() => {
      window.location.reload();
    }, 1500);
  };

  const handleMembershipCreated = (membershipData) => {
    // Only proceed if we actually have valid membership data
    if (!membershipData || !membershipData.name) {
      console.log('handleMembershipCreated called without valid data, ignoring');
      return;
    }
    
    console.log('Membership successfully created:', membershipData);
    
    // Show success message
    setSnackbarMessage(`Membership "${membershipData.name}" created successfully!`);
    setSnackbarOpen(true);
    
    // Refresh the page to show the new membership after a short delay
    setTimeout(() => {
      window.location.reload();
    }, 1500);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  return (
    <div className="create-button-container">
      {isMenuOpen && (
        <div className="create-menu">
          <div 
            className="create-option"
            onClick={() => handleOptionClick('event')}
          >
            <FontAwesomeIcon icon={faCalendarAlt} className="option-icon" />
            <span>Event</span>
          </div>
          <div 
            className="create-option"
            onClick={() => handleOptionClick('class')}
          >
            <FontAwesomeIcon icon={faMicrophone} className="option-icon" />
            <span>Class</span>
          </div>
          {/* TEMPORARILY HIDDEN - Partnership option will be released later */}
          {/* 
          <div 
            className="create-option"
            onClick={() => handleOptionClick('membership')}
          >
            <FontAwesomeIcon icon={faHeart} className="option-icon" />
            <span>Partnership</span>
          </div>
          */}
        </div>
      )}
      
      <button 
        className={`create-button ${isMenuOpen ? 'active' : ''}`} 
        onClick={toggleMenu}
      >
        {isMenuOpen ? (
          <FontAwesomeIcon icon={faTimes} />
        ) : (
          <img 
            src="/assets/RocketIcon.png" 
            alt="Create" 
            className="w-4 h-4"
            style={{ filter: 'brightness(0) invert(1)' }}
          />
        )}
      </button>

      <CreateEventModal 
        isOpen={isEventModalOpen}
        onClose={() => setIsEventModalOpen(false)}
        groupId={groupId}
        onEventCreated={handleEventCreated}
      />

      <CreateClassModal 
        isOpen={isClassModalOpen}
        onClose={() => setIsClassModalOpen(false)}
        groupId={groupId}
        onClassCreated={handleClassCreated}
      />

      <CreateMembershipModal
        isOpen={isMembershipModalOpen}
        onClose={() => setIsMembershipModalOpen(false)}
        groupId={groupId}
        onMembershipCreated={handleMembershipCreated}
      />

      <Snackbar 
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          onClose={handleSnackbarClose} 
          severity="success" 
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default CreateButton;